import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { TemporaryHealthcareAides } from './pages/TemporaryHealthcareAides';
import { RegisteredNurses } from './pages/RegisteredNurses';
import { RegisteredPracticalNurses } from './pages/RegisteredPracticalNurses';
import { PersonalSupportWorkers } from './pages/PersonalSupportWorkers';
import { InHomeNursing } from './pages/InHomeNursing';
import { DementiaCare } from './pages/DementiaCare';
import { PersonalCareServices } from './pages/PersonalCareServices';
import { WhyUs } from './pages/WhyUs';
import { Blog } from './pages/Blog';
import { FAQ } from './pages/FAQ';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/services/tha" element={<TemporaryHealthcareAides data-id="element-5" />} data-id="element-4" />
        <Route path="/services/rn" element={<RegisteredNurses data-id="element-7" />} data-id="element-6" />
        <Route path="/services/rpn" element={<RegisteredPracticalNurses data-id="element-9" />} data-id="element-8" />
        <Route path="/services/psw" element={<PersonalSupportWorkers data-id="element-11" />} data-id="element-10" />
        <Route path="/services/in-home-nursing" element={<InHomeNursing data-id="element-13" />} data-id="element-12" />
        <Route path="/services/dementia-care" element={<DementiaCare data-id="element-15" />} data-id="element-14" />
        <Route path="/services/personal-care" element={<PersonalCareServices data-id="element-17" />} data-id="element-16" />
        <Route path="/why-us" element={<WhyUs data-id="element-19" />} data-id="element-18" />
        <Route path="/blog" element={<Blog data-id="element-21" />} data-id="element-20" />
        <Route path="/faq" element={<FAQ data-id="element-23" />} data-id="element-22" />
        <Route path="/contact" element={<Contact data-id="element-25" />} data-id="element-24" />
      </Routes>
    </Router>;
}